import React from 'react';

const STATUS_CONFIG = {
  borrador: { label: 'Borrador', classes: 'bg-slate-100 text-slate-700 border border-slate-300' },
  en_revision: { label: 'En Revisión', classes: 'bg-blue-100 text-blue-800 border border-blue-200' },
  regresada: { label: 'Regresada', classes: 'bg-orange-100 text-orange-800 border border-orange-200' },
  // #Fase1-4 — El estado visible no cambia los filtros de publicación.
  publicada_con_bloqueo: {
    label: 'Publicada con bloqueo',
    classes: 'bg-red-100 text-red-800 border border-red-300',
  },
  publicada: { label: 'Publicada', classes: 'bg-green-100 text-green-800 border border-green-200' },
  archivada: { label: 'Archivada', classes: 'bg-slate-200 text-slate-600 border border-slate-300' },
};

export default function StatusBadge({ status }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.borrador;
  return (
    <span
      data-testid="status-badge"
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${cfg.classes}`}
    >
      {cfg.label}
    </span>
  );
}
